import React from "react";
import axiosInstance from "../../api/axiosInstance";
import { NavLink } from "react-router-dom";
import { apiurl, formatMoney } from "../../App";
import { withTranslation } from "react-i18next";
import MedicineModal from "../PrescriptionEntry/MedicineModal";
import Cookies from "js-cookie";
import dateFormat from "dateformat";
import { initEncryptionSession } from "../../encryptionSession";
import { encryptData, decryptData } from "../Crypto_Helpers/cryptoHelper";
import {
  HiOutlineDocumentText,
  HiOutlineEye,
  HiOutlineRefresh,
  HiOutlineClock,
  HiOutlineCash,
  HiOutlineCheckCircle,
  HiOutlineShoppingCart,
  HiOutlineArchive,
  HiOutlineXCircle,
  HiOutlineBadgeCheck,
} from "react-icons/hi";

class PendingApprovalsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      tableData: [],
      rawTransactions: [],
      props_loading: true,
      medicineModalOpen: false,
      pdfData: null,
      medicineList: null,
      updatingId: null,
      page: 1,
      rowsPerPage: 25,
    };
  }

  componentDidMount() {
    this.getTableData();
    this.intervalId = setInterval(this.getTableData, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  getTableData = async () => {
    this.setState({ props_loading: true });
    try {
      const aesKey = await initEncryptionSession();
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        0;

      const data = {
        pharmacy_id: Number(pharmId) || 0,
        date: "",
        date_to: "",
        doctor_id: 0,
        status: 0,
      };

      let requestPayload = data;
      if (aesKey) {
        try {
          const encrypted = await encryptData(data, aesKey);
          requestPayload = { objects: encrypted };
        } catch (e) {
          requestPayload = data;
        }
      }

      const response = await axiosInstance.post(
        "pharmacy/getPrescriptionInfo",
        requestPayload
      );

      let list = [];
      if (response && response.data) {
        if (Array.isArray(response.data.data)) {
          list = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            list = await decryptData(response.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      // Filter for Pending Approvals (quote sent, waiting for patient approval & payment)
      const isPendingApproval = (val) => {
        const s = (val.status || "").toLowerCase().trim();
        const statusId = Number(val.status_id) || 0;
        const isCancelled = Number(val.is_cancelled_order) === 1 || s.includes("cancel");
        if (isCancelled) return false;

        const isPaid = Number(val.payment_status) === 1 || statusId === 8 || s === "delivered" || s === "completed";
        if (isPaid) return false;

        const hasAmount = val.total_amount && Number(val.total_amount) > 0;
        return (
          statusId === 1 ||
          statusId === 2 ||
          s.includes("approval") ||
          s.includes("quote sent") ||
          (hasAmount && !isPaid)
        );
      };

      const pendingApprovalsList = Array.isArray(list) ? list.filter(isPendingApproval) : [];

      const sortedList = [...pendingApprovalsList].sort((a, b) => {
        const idA = Number(a.prescription_id || a.id || 0);
        const idB = Number(b.prescription_id || b.id || 0);
        return idB - idA;
      });

      const tableData = [];
      sortedList.forEach((val) => {
        let amount = parseFloat(val.total_amount) || parseFloat(val.billed_amount) || 0;
        if (!amount && (val.p_medicinedetails || val.medicines)) {
          try {
            const meds = typeof (val.p_medicinedetails || val.medicines) === "string"
              ? JSON.parse(val.p_medicinedetails || val.medicines)
              : (val.p_medicinedetails || val.medicines);
            if (Array.isArray(meds)) {
              amount = meds.reduce((sum, m) => {
                const p = parseFloat(m.price) || parseFloat(m.amount) || (parseFloat(m.per_tablet_price) || parseFloat(m.unit_rate) || 0) * (Number(m.totalmedicine) || Number(m.quantity) || 1);
                return sum + p;
              }, 0);
            }
          } catch (_) {}
        }

        tableData.push({
          orderId: val.custom_order_id || `PHAR${val.prescription_id || val.id}`,
          prescriptionId: val.prescription_id || val.id,
          order_id: val.order_id || val.id,
          customer: val.customer || val.name || "Patient",
          gender: val.gender || "-",
          customer_phno: val.phone_no || val.phonenumber || "-",
          doctorName: val.doctor_name || val.doctorName ? `Dr. ${val.doctor_name || val.doctorName}` : "Clinic Doctor",
          status: val.status || "Awaiting Member Approval",
          prescript_date: val.prescript_date || val.appointment_date || val.created_on || "",
          quoted_amount: amount,
          rawItem: val,
        });
      });

      this.setState({
        tableData,
        rawTransactions: sortedList,
        props_loading: false,
      });
    } catch (err) {
      console.error("PendingApprovalsTable getTableData error:", err);
      this.setState({ props_loading: false });
    }
  };

  handleMarkApproved = async (item) => {
    if (!window.confirm(`Mark prescription ${item.orderId} as Approved & Paid by patient?`)) return;

    this.setState({ updatingId: item.prescriptionId });
    try {
      const pharmId = Cookies.get("pharmacy_id") || localStorage.getItem("pharmacy_id") || 0;
      await axiosInstance.post("pharmacy/updateOrderStatus", {
        order_id: item.order_id || item.prescriptionId,
        prescription_id: item.prescriptionId,
        status_id: 8, // Direct completion / paid
        payment_status: 1,
        pharmacy_id: Number(pharmId),
      });
      alert("Order approved and marked completed successfully!");
      this.getTableData();
    } catch (err) {
      console.error("handleMarkApproved error:", err);
      alert("Failed to update status.");
    } finally {
      this.setState({ updatingId: null });
    }
  };

  handleViewDetails = (item) => {
    this.setState({
      pdfData: item.rawItem,
      medicineList: item.rawItem.p_medicinedetails || item.rawItem.medicines,
      medicineModalOpen: true,
    });
  };

  handleCloseMedicineModal = () => {
    this.setState({ medicineModalOpen: false });
  };

  searchChange = (e) => {
    this.setState({ search: e.target.value, page: 1 });
  };

  render() {
    const { t } = this.props;
    const searchStr = (this.state.search || "").trim().toLowerCase();

    const filteredData = this.state.tableData.filter((item) => {
      if (!searchStr) return true;
      const idMatch = (item.orderId || "").toLowerCase().includes(searchStr) ||
                      String(item.prescriptionId || "").toLowerCase().includes(searchStr);
      const nameMatch = (item.customer || "").toLowerCase().includes(searchStr);
      const phoneMatch = (item.customer_phno || "").toLowerCase().includes(searchStr);
      const doctorMatch = (item.doctorName || "").toLowerCase().includes(searchStr);
      return idMatch || nameMatch || phoneMatch || doctorMatch;
    });

    const currentPage = this.state.page || 1;
    const pageSize = this.state.rowsPerPage || 25;
    const totalPages = Math.ceil(filteredData.length / pageSize) || 1;
    const paginatedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const getPageNumbers = (current, total) => {
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    };

    const pageNumbers = getPageNumbers(currentPage, totalPages);

    return (
      <div className="p-4 sm:p-5 max-w-[1600px] mx-auto space-y-4 sm:space-y-5 animate-fadeIn">
        {/* Workflow Phase Switcher Tabs */}
        <div className="flex flex-wrap items-center gap-2 p-1.5 bg-white rounded-2xl border border-gray-100 shadow-2xs">
          <NavLink
            to="/Home/prescription"
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold text-gray-600 hover:text-gray-900 hover:bg-gray-50 no-underline transition-all"
          >
            <HiOutlineDocumentText size={16} />
            Today's Prescriptions
          </NavLink>
          <NavLink
            to="/Home/pending_quotes"
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold text-gray-600 hover:text-gray-900 hover:bg-gray-50 no-underline transition-all"
          >
            <HiOutlineClock size={16} />
            Pending Quotes
          </NavLink>
          <NavLink
            to="/Home/pending_approvals"
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold bg-blue-50 text-blue-800 border border-blue-200/60 no-underline transition-all shadow-2xs"
          >
            <HiOutlineCheckCircle size={16} className="text-blue-600" />
            Pending Approvals
            <span className="px-1.5 py-0.2 rounded-full bg-blue-200/80 text-blue-900 text-[10px] font-black ml-1">
              {filteredData.length}
            </span>
          </NavLink>
          <NavLink
            to="/Home/pending_orders"
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold text-gray-600 hover:text-gray-900 hover:bg-gray-50 no-underline transition-all"
          >
            <HiOutlineShoppingCart size={16} />
            Pending Orders
          </NavLink>
          <NavLink
            to="/Home/totalorders"
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold text-gray-600 hover:text-gray-900 hover:bg-gray-50 no-underline transition-all"
          >
            <HiOutlineArchive size={16} />
            Completed Prescriptions
          </NavLink>
          <NavLink
            to="/Home/cancelorders"
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold text-gray-600 hover:text-gray-900 hover:bg-gray-50 no-underline transition-all"
          >
            <HiOutlineXCircle size={16} />
            Canceled Quotes
          </NavLink>
        </div>

        {/* Top Header Card */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs">
          <div className="flex items-center gap-3">
            <NavLink
              to="/Home/dashboard"
              className="w-8 h-8 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white flex items-center justify-center transition-all duration-300 shadow-2xs active:scale-95 group"
              title="Back to Dashboard"
            >
              <svg className="w-4 h-4 stroke-[2.5] transform group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </NavLink>
            <div>
              <div className="flex items-center gap-2">
                <h1 className="text-base sm:text-lg font-bold text-gray-900 tracking-tight">
                  Pending <span className="text-blue-600">Member Approvals</span>
                </h1>
                <span className="px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 text-[10px] font-bold border border-blue-200">
                  {filteredData.length} {filteredData.length === 1 ? "quote sent" : "quotes sent"}
                </span>
              </div>
              <p className="text-xs text-gray-500 font-medium mt-0.5">
                Quotations sent to patients, waiting for member approval or in-person payment confirmation
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2.5">
            {/* Search Input */}
            <div className="relative min-w-[240px]">
              <input
                type="text"
                placeholder="Search patient, presc ID, phone, doctor..."
                value={this.state.search}
                onChange={this.searchChange}
                className="w-full pl-9 pr-3 py-1.5 rounded-lg border border-gray-300 bg-gray-50/50 focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            {/* Refresh Button */}
            <button
              type="button"
              onClick={this.getTableData}
              className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-bold rounded-lg transition-all active:scale-95 cursor-pointer"
              title="Refresh Approvals"
            >
              <HiOutlineRefresh size={14} className={this.state.props_loading ? "animate-spin" : ""} />
              Refresh
            </button>
          </div>
        </div>

        {/* Table Container Card */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-2xs overflow-hidden flex flex-col">
          <div className="overflow-x-auto w-full">
            <table className="w-full text-left border-collapse min-w-[950px]">
              <thead>
                <tr className="bg-slate-50/90 border-b border-gray-200 text-xs font-bold text-slate-700 uppercase tracking-wider select-none">
                  <th className="py-2.5 px-3 text-center w-12">S.No</th>
                  <th className="py-2.5 px-3 text-center w-36">Prescription ID</th>
                  <th className="py-2.5 px-4 text-left min-w-[180px]">Patient Name</th>
                  <th className="py-2.5 px-3 text-center w-24">Gender</th>
                  <th className="py-2.5 px-3 text-center w-36">Phone No</th>
                  <th className="py-2.5 px-4 text-left min-w-[200px]">Doctor</th>
                  <th className="py-2.5 px-3 text-right w-32">Quoted Amount</th>
                  <th className="py-2.5 px-3 text-center w-32">Status</th>
                  <th className="py-2.5 px-3 text-center w-44">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 text-xs font-medium text-slate-700">
                {this.state.props_loading ? (
                  <tr>
                    <td colSpan="9" className="py-12 text-center text-gray-400">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                        <span>Loading pending approvals...</span>
                      </div>
                    </td>
                  </tr>
                ) : paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="py-12 text-center text-gray-400">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <HiOutlineCheckCircle size={32} className="text-gray-300" />
                        <span className="text-xs font-medium">No pending member approvals found</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, index) => {
                    const sNo = (currentPage - 1) * pageSize + index + 1;
                    return (
                      <tr
                        key={item.prescriptionId || index}
                        className="hover:bg-slate-50/80 transition-colors"
                      >
                        <td className="py-2.5 px-3 text-center text-gray-500 font-semibold">{sNo}</td>
                        <td className="py-2.5 px-3 text-center font-bold text-teal-700 font-mono">
                          {item.orderId}
                        </td>
                        <td className="py-2.5 px-4 text-left font-bold text-gray-900">
                          {item.customer}
                        </td>
                        <td className="py-2.5 px-3 text-center text-gray-600 capitalize">
                          {item.gender}
                        </td>
                        <td className="py-2.5 px-3 text-center text-gray-600 font-mono">
                          {item.customer_phno}
                        </td>
                        <td className="py-2.5 px-4 text-left text-gray-800">
                          {item.doctorName}
                        </td>
                        <td className="py-2.5 px-3 text-right font-bold text-teal-700">
                          {item.quoted_amount > 0 ? `₹ ${parseFloat(item.quoted_amount).toFixed(2)}` : "-"}
                        </td>
                        <td className="py-2.5 px-3 text-center">
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold bg-blue-50 text-blue-700 border border-blue-200">
                            <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                            {item.status || "Quote Sent"}
                          </span>
                        </td>
                        <td className="py-2.5 px-3 text-center">
                          <div className="flex items-center justify-center gap-1.5">
                            <button
                              type="button"
                              onClick={() => this.handleMarkApproved(item)}
                              disabled={this.state.updatingId === item.prescriptionId}
                              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs transition-all shadow-2xs active:scale-95 cursor-pointer disabled:opacity-50"
                              title="Confirm In-Person Payment & Dispense"
                            >
                              <HiOutlineBadgeCheck size={14} />
                              {this.state.updatingId === item.prescriptionId ? "Processing..." : "Approve & Pay"}
                            </button>
                            <button
                              type="button"
                              onClick={() => this.handleViewDetails(item)}
                              className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-xs transition-all cursor-pointer"
                              title="View Quote Details"
                            >
                              <HiOutlineEye size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Footer */}
          {!this.state.props_loading && filteredData.length > 0 && (
            <div className="p-3 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs select-none">
              <span className="text-gray-500 font-medium">
                Showing <span className="font-bold text-gray-900">{(currentPage - 1) * pageSize + 1}</span> to{" "}
                <span className="font-bold text-gray-900">{Math.min(currentPage * pageSize, filteredData.length)}</span> of{" "}
                <span className="font-bold text-gray-900">{filteredData.length}</span> entries
              </span>

              <div className="flex items-center gap-1">
                <button
                  onClick={() => this.setState({ page: Math.max(1, currentPage - 1) })}
                  disabled={currentPage === 1}
                  className="px-2.5 py-1 rounded border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all font-semibold"
                >
                  Prev
                </button>
                {pageNumbers.map((num) => (
                  <button
                    key={num}
                    onClick={() => this.setState({ page: num })}
                    className={`px-2.5 py-1 rounded border font-semibold transition-all ${
                      currentPage === num
                        ? "bg-teal-600 border-teal-600 text-white"
                        : "border-gray-200 text-gray-700 hover:bg-gray-50"
                    }`}
                  >
                    {num}
                  </button>
                ))}
                <button
                  onClick={() => this.setState({ page: Math.min(totalPages, currentPage + 1) })}
                  disabled={currentPage === totalPages}
                  className="px-2.5 py-1 rounded border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all font-semibold"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>

        {/* View Quote Details Modal */}
        {this.state.medicineModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs overflow-y-auto animate-fadeIn">
            <div className="bg-white rounded-2xl max-w-4xl w-full p-6 max-h-[90vh] overflow-y-auto shadow-2xl">
              <MedicineModal
                data={this.state.medicineList}
                pdfData={this.state.pdfData}
                onClose={this.handleCloseMedicineModal}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(PendingApprovalsTable);
